class APIS {
	apis() {
		return {
			facebookPostsOnboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/onboarding/fb-pages'
			},
			facebookPostsGetAllPosts: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post/get-all'
			},
			facebookPostsGetPostById: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post/get-by-id'
			},
			facebookPostsPublishPost: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post/publish'
			},
			facebookPostsGetAllOnboardedPages: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fb-post/pages'
			},
			facebookPostsDeletePost: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post/delete'
			},
			facebookPostsCommentsAddComment: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post-comment/publish'
			},
			facebookPostsCommentsUpdateComment: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post-comment/edit'
			},
			facebookPostsCommentsGetComments: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post-comment/get-thread'
			},
			facebookPostsCommentsDeleteComment: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post-comment/remove'
			},
			facebookPostsCommentsReactionsGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-comment-reaction/get-by-comment'
			},
			facebookPostsReactionsGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/facebook-post/get-reactions'
			}
		};
	}
}

export default new APIS();
